<template>
  <div id="form">
    <h2>Lückentext</h2>
    <br><br>
    <p style="text-align: left;">
        Ein großer Bestandteil der Audio sind Mikrofone, die zur Aufnahme von Ton und Sprache dienen.
        Mikrofone wandeln akustische Schallgrößen (Druck, Schnellte) in elektrische Größen ( Spannung, Strom). Dabei gibt es unterschiedliche Wandlerprinzipien.
        Es ist maßgebend für die Qualität des Ausgangssignals, welche durch Rauschabstand, Impulstreue und Klirrfaktor bestimmt wird. 
        Jedes Wandlerprinzip beeinflusst die Mikroeigenschaften entscheidend.
    </p>
    <p style="text-align: left;">
        Die bekanntesten Wandlerprinzipien sind das <input v-model="message1" placeholder="Feld1" /> Prinzip, 
        sowie das <input v-model="message2" placeholder="Feld2" /> Prinzip. 
    </p>

    <button id="button2" v-on:click="check">
        Prüfen
    </button>

  </div>
</template>
<script>

export default {
  name: "two-lists",
  display: "Two Lists",
  order: 1,

  data() {
    return {
        message1: '',
        message2: '',
        // message3: '',
    }
  },
  methods: {
    log: function(evt) {
      window.console.log(evt);
    },
    check() {
        if ( ((this.message1 && this.message1 == "Elektrodynamische" || this.message1 == "elektrodynamische") &&
             (this.message2 && this.message2 == "Elektrostatische" || this.message2 == "elektrostatische")) ||
             ((this.message1 && this.message1 == "Elektrostatische" || this.message1 == "elektrostatische") &&
             (this.message2 && this.message2 == "Elektrodynamische" || this.message2 == "elektrodynamische"))
            ){
                alert("richtig");
                this.$store.commit('setTaskCompletionState', {varname: "audioForm_done", state: true})
                localStorage.setItem("audioForm_done", true);
            }
        else {
            alert("falsch")
        }
    }
  }
};
</script>

<style scoped>
/* #input1 {
    position: absolute;
    left: 260px;
    top: 305px
} */
/* #input2 {
    position: absolute;
    left: 530px;
    top: 205px
} */

#button2 {
    position: absolute;
    left: 650px;
    top: 550px;
    font-family: sans-serif;
    font-size: 20px;
    /* background-color: #297; */
    color: #fff;
    border: 0px;
    border-radius: 3px;
    padding: 20px;
    cursor: pointer;
    margin-bottom: 20px;
    background-color: #528382
}
#form {
    height: 1000px;;
}
</style>